// Copyright (c) 2025 WiseTime. All rights reserved.

import { combineEpics } from "redux-observable"
import { Action } from "redux"
import type { RootState } from "../../../app/store"
import getDefaultNarratePreferences from "./getDefaultNarratePreferences"
import getSavedNarratePreferences from "./getSavedNarratePreferences"
import setNarratePreferences from "./setNarratePreferences"
import listTrainingGroups from "./listTrainingGroups"
import getTrainingNarrative from "./getTrainingNarrative"

export default combineEpics<Action, Action, RootState, unknown>(
  getDefaultNarratePreferences,
  getSavedNarratePreferences,
  setNarratePreferences,
  listTrainingGroups,
  getTrainingNarrative,
)
